import React, { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { Button } from "semantic-ui-react";
import { ModalBuilder, Modal, Form, useFormState } from "@redriver/cinnamon";
import { addSite } from "./actions";
import { checkValidSiteName } from "./actions";
import { groupsLookup } from "modules/lookups";

const AddSite = ({ as: As = Button, onAdded, ...props }) => {
  const dispatch = useDispatch();
  const formState = useFormState();

  const [checkingName, setCheckingName] = useState(false);
  const [isValidName, setIsValidName] = useState(false);
  const [formValid, setFormValid] = useState(false);
  const [showErrors, setShowErrors] = useState(false);

  const setNameIsValidFromResponse = useCallback(
    (response) => {
      setIsValidName(
        !!response &&
          (!formState.errors.name || formState.errors.name.length == 0)
      );
    },
    [formState.errors]
  );

  return (
    <ModalBuilder
      withForm
      submitAction={addSite}
      onSubmitted={() => {
        if (onAdded) onAdded();
        setShowErrors(false);
        setIsValidName(false);
      }}
      renderTrigger={(showModal) => <As onClick={showModal} {...props} />}
      renderModal={(modalProps, formProps, state, events) => (
        <Modal
          {...modalProps}
          header="Add Site"
          submitLabel="Add"
          size="tiny"
          onSubmit={() => {
            setShowErrors(true);
            if (formValid && isValidName && !checkingName) {
              events.onSubmit();
            }
          }}
        >
          <Form
            {...formProps}
            onValidated={(isValid) => setFormValid(isValid)}
            showErrors={showErrors}
          >
            {(fields, errors) => (
              <React.Fragment>
                <Form.Input
                  label="Name"
                  field="name"
                  fluid
                  required
                  showErrors={showErrors || (!isValidName && !!fields.name)}
                  customValidator={() => {
                    if (formProps.value.name) {
                      setCheckingName(true);
                      dispatch(checkValidSiteName(formProps.value.name))
                        .then((result) => {
                          if (result.success && result.response != null) {
                            setNameIsValidFromResponse(result.response);
                          }
                        })
                        .finally(() => setCheckingName(false));
                    }
                  }}
                  customErrors={
                    !checkingName && !isValidName && !!fields.name
                      ? ["Duplicate site name, please choose another"]
                      : errors.name
                  }
                />

                <Form.TypeAhead
                  field="groupIds"
                  label="Groups"
                  fluid
                  multiple
                  lookup={groupsLookup}
                />
              </React.Fragment>
            )}
          </Form>
        </Modal>
      )}
    />
  );
};

export default AddSite;
